// extracted by mini-css-extract-plugin
module.exports = {"CountriesFeature":"jz_a"};